import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

const STAFF_ROLES = ['super_admin', 'admin', 'deal_manager', 'content_manager', 'investor_relations', 'view_only'];

export default function ProtectedRoute({ children, requiredRole, allowPending }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#A0743A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Staff roles bypass pending check
  if (STAFF_ROLES.includes(user.role)) {
    if (requiredRole === 'admin') return children;
    return children;
  }

  // Non-staff: check if pending and redirect to pending page
  if (user.status === 'pending' && !allowPending) {
    return <Navigate to="/pending" replace />;
  }

  if (user.status === 'rejected') {
    return <Navigate to="/pending" replace />;
  }

  if (requiredRole === 'admin') {
    return <Navigate to="/portal" replace />;
  }

  return children;
}
